import { render } from "./SmartFormStatus.vue?vue&type=template&id=35fb585d&ts=true"
import script from "./SmartFormStatus.vue?vue&type=script&lang=ts"
export * from "./SmartFormStatus.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__